// extracted by mini-css-extract-plugin
export default {"loadingSpinner-container":"Automations_loadingSpinner-container__WM6W2"};